import { z } from 'zod';

export const ALLOWED_INPUT_ATTACHMENT_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'audio/mpeg',
  'video/mp4',
  'text/csv',
  'image/jpeg',
  'image/png',
] as const;

export const INPUT_ATTACHMENT_MAX_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

// stored in DB, has fileUri, no url
export const InputAttachmentSchema = z.object({
  type: z.literal('file'),
  identifier: z.uuid(),
  fileUri: z.string(),
  name: z.string(),
  mimeType: z.enum(ALLOWED_INPUT_ATTACHMENT_MIME_TYPES),
  sizeBytes: z.number().int().positive().max(INPUT_ATTACHMENT_MAX_SIZE_BYTES),
  checksum: z.string().optional(),
});

export type InputAttachment = z.infer<typeof InputAttachmentSchema>;

// sent to DS agent, has url, no fileUri
export const InputAttachmentPayloadSchema = z.object({
  type: z.literal('file'),
  identifier: z.uuid(),
  url: z.url(),
  name: z.string(),
  mimeType: z.enum(ALLOWED_INPUT_ATTACHMENT_MIME_TYPES),
  sizeBytes: z.number().int().positive().max(INPUT_ATTACHMENT_MAX_SIZE_BYTES),
});

export type InputAttachmentPayload = z.infer<typeof InputAttachmentPayloadSchema>;

// Response shape for a single file from the upload-credentials endpoint
export const UploadCredentialSchema = z.object({
  identifier: z.string(),
  credentials: z.object({
    accessKeyId: z.string(),
    secretAccessKey: z.string(),
    sessionToken: z.string(),
    expiration: z.string(),
  }),
  bucket: z.string(),
  s3Key: z.string(),
  region: z.string(),
});

export type UploadCredential = z.infer<typeof UploadCredentialSchema>;
